import React, { useState, useEffect } from "react";

import CTA from "../components/CTA";
import InfoCard from "../components/Cards/InfoCard";
import ChartCard from "../components/Chart/ChartCard";
import { Doughnut, Line } from "react-chartjs-2";
import ChartLegend from "../components/Chart/ChartLegend";
import PageTitle from "../components/Typography/PageTitle";
import { ChatIcon, CartIcon, MoneyIcon, PeopleIcon } from "../icons";
import RoundIcon from "../components/RoundIcon";
import response from "../utils/demo/tableData";
import {
  TableBody,
  TableContainer,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  TableFooter,
  Avatar,
  Badge,
  Pagination,
} from "@windmill/react-ui";

import {
  doughnutOptions,
  lineOptions,
  doughnutLegends,
  lineLegends,
} from "../utils/demo/chartsData";

import {
  PhotoIcon,
  GifIcon,
  VideoCameraIcon,
  DocumentTextIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import Image1 from "../assets/img/create-account-office-dark.jpeg";
import Image2 from "../assets/img/create-account-office.jpeg";
import Image3 from "../assets/img/forgot-password-office-dark.jpeg";
import Image4 from "../assets/img/forgot-password-office.jpeg";
import FolderCard from "../components/Cards/FolderCard";
function Dashboard() {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);

  // pagination setup
  const resultsPerPage = 10;
  const totalResults = response.length;

  // pagination change control
  function onPageChange(p) {
    setPage(p);
  }

  // on page change, load new sliced data
  // here you would make another server request for new data
  useEffect(() => {
    setData(response.slice((page - 1) * resultsPerPage, page * resultsPerPage));
  }, [page]);

  return (
    <>
      <PageTitle>Favorite Files</PageTitle>

      <TableContainer>
        <Table>
          <TableHeader>
            <tr>
              <TableCell>Name</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Own</TableCell>
              <TableCell>File Size</TableCell>
            </tr>
          </TableHeader>
          <TableBody>
            {data.map((user, i) => (
              <TableRow>
                <TableCell>
                  <div className="flex items-center text-sm">
                    <PhotoIcon className="h-8 text-red-500 pr-2" />
                    <div>
                      <p className="font-semibold">img.jpg</p>
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <span className="text-sm">$ {user.amount}</span>
                </TableCell>
                <TableCell>
                  <Badge type={user.status}>{user.status}</Badge>
                </TableCell>
                <TableCell>
                  <span className="text-sm">
                    {new Date(user.date).toLocaleDateString()}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TableFooter>
          <Pagination
            totalResults={totalResults}
            resultsPerPage={resultsPerPage}
            label="Table navigation"
            onChange={onPageChange}
          />
        </TableFooter>
      </TableContainer>
    </>
  );
}

export default Dashboard;

// import React from "react";

// import CTA from "../components/CTA";
// import PageTitle from "../components/Typography/PageTitle";
// import SectionTitle from "../components/Typography/SectionTitle";
// import { Input, HelperText, Label, Select, Textarea } from "@windmill/react-ui";

// import { MailIcon } from "../icons";

// function Forms() {
//   return (
//     <>
//       <PageTitle>Forms</PageTitle>
//       <CTA />
//       <SectionTitle>Elements</SectionTitle>

//       <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
//         <Label>
//           <span>Name</span>
//           <Input className="mt-1" placeholder="Jane Doe" />
//         </Label>

//         <Label className="mt-4">
//           <span>Disabled</span>
//           <Input disabled className="mt-1" placeholder="Jane Doe" />
//         </Label>

//         <div className="mt-4">
//           {/* TODO: Check if this label is accessible, or fallback */}
//           {/* <span className="text-sm text-gray-700 dark:text-gray-400">Account Type</span> */}
//           <Label>Account Type</Label>
//           <div className="mt-2">
//             <Label radio>
//               <Input type="radio" value="personal" name="accountType" />
//               <span className="ml-2">Personal</span>
//             </Label>
//             <Label className="ml-6" radio>
//               <Input type="radio" value="business" name="accountType" />
//               <span className="ml-2">Business</span>
//             </Label>
//             <Label disabled className="ml-6" radio>
//               <Input
//                 disabled
//                 type="radio"
//                 value="disabled"
//                 name="accountType"
//               />
//               <span className="ml-2">Disabled</span>
//             </Label>
//           </div>
//         </div>

//         <Label className="mt-4">
//           <span>Requested Limit</span>
//           <Select className="mt-1">
//             <option>$1,000</option>
//             <option>$5,000</option>
//             <option>$10,000</option>
//             <option>$25,000</option>
//           </Select>
//         </Label>

//         <Label className="mt-4">
//           <span>Multiselect</span>
//           <Select className="mt-1" multiple>
//             <option>Option 1</option>
//             <option>Option 2</option>
//             <option>Option 3</option>
//             <option>Option 4</option>
//             <option>Option 5</option>
//           </Select>
//         </Label>

//         <Label className="mt-4">
//           <span>Message</span>
//           <Textarea
//             className="mt-1"
//             rows="3"
//             placeholder="Enter some long form content."
//           />
//         </Label>

//         <Label className="mt-6" check>
//           <Input type="checkbox" />
//           <span className="ml-2">
//             I agree to the <span className="underline">privacy policy</span>
//           </span>
//         </Label>
//       </div>

//       <SectionTitle>Validation</SectionTitle>

//       <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
//         <Label>
//           <span>Invalid input</span>
//           <Input className="mt-1" valid={false} placeholder="Jane Doe" />
//           <HelperText valid={false}>Your password is too short.</HelperText>
//         </Label>

//         <Label className="mt-4">
//           <span>Valid input</span>
//           <Input className="mt-1" valid={true} placeholder="Jane Doe" />
//           <HelperText valid={true}>Your password is strong.</HelperText>
//         </Label>

//         <Label className="mt-4">
//           <span>Helper text</span>
//           <Input className="mt-1" placeholder="Jane Doe" />
//           <HelperText>
//             Your password must be at least 6 characters long.
//           </HelperText>
//         </Label>
//       </div>

//       {/* <!-- Inputs with icons --> */}
//       <SectionTitle>Icons</SectionTitle>

//       <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
//         <Label>
//           <span>Icon left</span>
//           {/* <!-- focus-within sets the color for the icon when input is focused --> */}
//           <div className="relative text-gray-500 focus-within:text-purple-600 dark:focus-within:text-purple-400">
//             <input
//               className="block w-full pl-10 mt-1 text-sm text-black dark:text-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:focus:shadow-outline-gray form-input"
//               placeholder="Jane Doe"
//             />
//             <div className="absolute inset-y-0 flex items-center ml-3 pointer-events-none">
//               <MailIcon className="w-5 h-5" aria-hidden="true" />
//             </div>
//           </div>
//         </Label>

//         <Label className="mt-4">
//           <span className="text-gray-700 dark:text-gray-400">Icon right</span>
//           {/* <!-- focus-within sets the color for the icon when input is focused --> */}
//           <div className="relative text-gray-500 focus-within:text-purple-600 dark:focus-within:text-purple-400">
//             <input
//               className="block w-full pr-10 mt-1 text-sm text-black dark:text-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:focus:shadow-outline-gray form-input"
//               placeholder="Jane Doe"
//             />
//             <div className="absolute inset-y-0 right-0 flex items-center mr-3 pointer-events-none">
//               <MailIcon className="w-5 h-5" aria-hidden="true" />
//             </div>
//           </div>
//         </Label>
//       </div>

//       {/* <!-- Inputs with buttons --> */}
//       <SectionTitle>Buttons</SectionTitle>

//       <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
//         <Label>
//           <span>Button left</span>
//           <div className="relative">
//             <input
//               className="block w-full pl-20 mt-1 text-sm dark:text-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:focus:shadow-outline-gray form-input"
//               placeholder="Jane Doe"
//             />
//             <button className="absolute inset-y-0 px-4 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-purple-600 border border-transparent rounded-l-md active:bg-blue-600 hover:bg-blue-700 focus:outline-none focus:shadow-outline-purple dark:focus:shadow-outline-gray">
//               Click
//             </button>
//           </div>
//         </Label>

//         <Label className="mt-4">
//           <span>Button right</span>
//           <div className="relative text-gray-500 focus-within:text-blue-600">
//             <input
//               className="block w-full pr-20 mt-1 text-sm text-black dark:text-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:shadow-outline-purple dark:focus:shadow-outline-gray form-input"
//               placeholder="Jane Doe"
//             />
//             <button className="absolute inset-y-0 right-0 px-4 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-r-md active:bg-blue-600 hover:bg-blue-700 focus:outline-none focus:shadow-outline-purple">
//               Click
//             </button>
//           </div>
//         </Label>
//       </div>
//     </>
//   );
// }

// export default Forms;
